import { Helmet } from '@dr.pogodin/react-helmet';
const Metadata = ({ title }) => {
  return (
    <Helmet>
      <title>{!title ? 'Releva' : `Releva | ${title}`}</title>
    </Helmet>
  );
};
export default Metadata;
